import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useCloseTab } from '../../components/tabs/TabsContext'
import { useApiProgress } from '../../hooks/ApiProgress'
import { toast } from 'react-toastify'
import { VALIDATION_MESSAGE } from '../../utils/constants'
import Input from '../../components/Input'
import Button from '../../components/Button'
import Spinner from '../../components/Spinner'
import { USER_PATH, changeUserPassword, getUserById, updateUser } from '../../api/userApi'

const UserEditPasswordPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const [entity, setEntity] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${USER_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${USER_PATH}`, false)
    const [password, setPassword] = useState('')

    useEffect(() => {
        getUserById(id).then(res => setEntity(res.data))
    }, [id])

    const onClickSubmit = () => {
        changeUserPassword(id, { password })
            .then(res => {
                closeTab()
                toast.success('Şifre güncellendi')
            }).catch(err => {
                toast.error(VALIDATION_MESSAGE)
                setErrors(err.response.data.validationErrors)
            })
    }

    useEffect(() => {
        setErrors(prevState => ({ ...prevState, password: undefined }))
    }, [password])

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )



    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Kullanıcı Şifre Değiştir</label>
                <Input
                    label='Yeni Şifre'
                    name='username'
                    placeholder='Yeni şifreyi girin...'
                    error={errors.password}
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default UserEditPasswordPage